import React from "react";
import styled from "styled-components";
import { RouteComponentProps, withRouter } from "react-router";
import { Capsule } from "@sonder/ui/source/styled/fragments/Capsule";
import { TabButton } from "@sonder/ui/source/styled/fragments/TabButton";
import { TabGroup } from "@sonder/ui/source/styled/fragments/TabGroup";
import { useSegment } from "analytics/segment";
import { TaskData } from "core/queries/GetTasks";
import { mapTaskFeedItemToUnread } from "core/queries/mappers";
import { isCleanTask, isSpaceCleanTask } from "tasks/helpers";

interface TaskPanelTabs extends RouteComponentProps {
  task: TaskData;
}

const TaskCapsule = styled(Capsule)`
  position: absolute;
  right: 0;
  transform: translate(75%, -37.5%) scale(0.75);
`;

export const TaskPanelTabs = withRouter(
  ({ task, history, location, match }: TaskPanelTabs) => {
    const { track } = useSegment();
    const baseRoute = match.url;
    const unreadCount = mapTaskFeedItemToUnread(task);

    const onTabClick = (tab?: string) => () => {
      // Our logic assumes that the `details` tab is the "homepage" of this view.
      track({
        action: "click",
        element: tab ? `${tab}_tab` : "details_tab",
        eventName: "task_panel_tabs",
      });
      history.push(tab ? `${baseRoute}/${tab}` : baseRoute);
    };
    return (
      <TabGroup>
        <TabButton
          selected={location.pathname === baseRoute}
          onClick={onTabClick()}
        >
          Details
        </TabButton>
        <TabButton
          selected={location.pathname === `${baseRoute}/activity`}
          onClick={onTabClick("activity")}
        >
          Activity
          {!!unreadCount && (
            <TaskCapsule>{unreadCount > 99 ? `99+` : unreadCount}</TaskCapsule>
          )}
        </TabButton>

        {!isCleanTask(task.type) && !isSpaceCleanTask(task.type) && (
          <TabButton
            selected={location.pathname === `${baseRoute}/guest`}
            onClick={onTabClick("guest")}
          >
            Guest
          </TabButton>
        )}

        {!isSpaceCleanTask(task.type) && (
          <TabButton
            selected={location.pathname === `${baseRoute}/unit`}
            onClick={onTabClick("unit")}
          >
            Unit
          </TabButton>
        )}
      </TabGroup>
    );
  },
);
